import { ChangeEvent, FunctionComponent, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import MultiSelect from "../../MultiSelect";
import "./styles.scss";
import Label from "../../Label";
import useDevice from "../../../utils/hooks/useDevice";
import classNames from "classnames";
import { Switch } from "../../common/Switch";

type Props = {
  handleFilterChange: (
    e: ChangeEvent<HTMLInputElement>,
    filter: Filter,
    options: MultiSelectOption[],
    mode: "multiselect" | "monoselect"
  ) => void;
  handleMultiselectFilter: () => void;
  setFilters: React.Dispatch<React.SetStateAction<any>>;
  setIsCustom: React.Dispatch<React.SetStateAction<any>>;
  isCustom: boolean;
  filters: ProductFilters;
  currentMultiSelectFilter: MultiSelectOption[];
  materialOptions: MultiSelectOption[];
  subcategoryOptions: MultiSelectOption[];
};

const CategoryHeader: FunctionComponent<Props> = ({
  handleFilterChange,
  handleMultiselectFilter,
  currentMultiSelectFilter,
  filters,
  materialOptions,
  subcategoryOptions,
  setFilters,
  setIsCustom,
  isCustom,
}) => {
  const location = useLocation();

  const [params, setParams] = useSearchParams();
  const fillCategory = () => {
    switch (location.pathname) {
      case "/category/chain":
        return "Cadenas";
      case "/category/pendant":
        return "Dijes";
      case "/category/ring":
        return "Anillos";
      case "/category/brazalete":
        return "Pulseras";
      case "/category/brazalete":
        return "Pulseras";
      case "/category/hoop":
        return "Aros";
      case "/category/finding":
        return "Fornituras";
      case "/contact":
        return "Contacto";
      default:
        return "Empty";
    }
  };
  const [categoryTitle, setCategoryTitle] = useState<string>("");
  useEffect(() => {
    setCategoryTitle(fillCategory);
  }, [, location]);
  const handleCleanFilter = () => {
    setIsCustom(false);
    setFilters({ material: [], subcategory: [] });
    setParams("");
  };

  const { width } = useDevice();

  return (
    <section className="category__header">
      {categoryTitle.length > 0 && <Label tag="h1">{categoryTitle}</Label>}
      {(filters.material.length > 0 || filters.subcategory.length > 0) &&
        width < 768 && (
          <p
            className="category__filter--title--mobile"
            onClick={handleCleanFilter}
          >
            Borrar filtros
          </p>
        )}
      <div className="category__filter">
        {(filters.material.length > 0 || filters.subcategory.length > 0) && (
          <p className="category__filter--title" onClick={handleCleanFilter}>
            Borrar filtros
          </p>
        )}
        {/*<Switch
          setState={setIsCustom}
          state={isCustom}
          label={"Personalizable"}
        />*/}
        <MultiSelect
          options={materialOptions}
          title="Material"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            handleFilterChange(e, "material", materialOptions, "monoselect")
          }
          selectedOptions={filters.material}
        />
        {subcategoryOptions && (
          <MultiSelect
            options={subcategoryOptions}
            buttonLabel="Filtrar"
            buttonAction={handleMultiselectFilter}
            title="Subcategorías"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleFilterChange(
                e,
                "subcategory",
                subcategoryOptions,
                "multiselect"
              )
            }
            selectedOptions={currentMultiSelectFilter}
          />
        )}
      </div>
    </section>
  );
};

export default CategoryHeader;
